import React from 'react';
import styles from './BaseTraitCard.module.scss';
import cls from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { GradientIcon, OffsetIcon } from 'components/Icons/Icons';

export enum TraitType {
  Shape,
  Color,
}

type TraitSourceProps = {
  type: TraitType;
  src?: string;
  className?: string;
};

export const TraitPreview = ({ className, type, src }: TraitSourceProps) => {
  const isOffsetOrGradient = src === 'offset' || src === 'gradient';
  return (
    <div className={className}>
      {type === TraitType.Shape && <LazyLoadImage src={src} />}
      {type === TraitType.Color && (
        <>
          {isOffsetOrGradient ? (
            <div className={styles.markingsColor}>
              {src === 'offset' && <OffsetIcon />}
              {src === 'gradient' && <GradientIcon />}
            </div>
          ) : (
            <div style={{ background: src }} className={styles.traitColor} />
          )}
        </>
      )}
    </div>
  );
};

export type BaseTraitCardProps = {
  className?: string;
  name: string;
  description: string;
  preview?: JSX.Element;
  small?: boolean;
};

export const BaseTraitCard = (props: BaseTraitCardProps) => {
  return (
    <div
      className={cls(
        props.small ? styles.baseCardSmall : styles.baseCard,
        styles.traitCard,
        props.className,
      )}
    >
      {props.preview}
      <div className={styles.traitContent}>
        <p className="small-title">{props.name}</p>
        <p
          className={cls(
            'm-0',
            'subheading-small',
            props.small ? styles.traitDescriptionSmall : styles.traitDescription,
          )}
        >
          {props.description}
        </p>
      </div>
    </div>
  );
};
